import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { query, where, collection, onSnapshot, orderBy, getDocs, updateDoc, doc } from "firebase/firestore";
import logo_default from "../../assets/logo_default.jpg";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdClose, MdOutlineReceiptLong, MdSettings } from "react-icons/md";
import Pos_receipt_master_create from "./pos_receipt_master_create.jsx";
import { Save_log_history } from "../../log_history_root/save_log_history.js";
 
import { Randomcode } from "../../components_root/rendom_code.js";
 
import { Save_voucher } from "../vouchers_root/save_voucher.js";
import { Create_ledger_account } from "../ledger_accounts_root/Create_ledger_account.js";
import { Ledger_accounts_manager } from "../ledger_accounts_root/ledger_accounts_manager.js"; 
export default function Pos_receipt_master() {
    const servicetablename = "accountingfinancedb";
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("vouchers");
    const [IsLoading2, setIsLoading2] = useState(true);
    const [isedit, setIsedit] = useState(false);
    const [vouchersdata, setVouchersdata] = useState([]);
    const [master_vouchers_listdata, setMaster_vouchers_listdata] = useState([]);
    const [masterdata, setMasterdata] = useState([]);
    const [voucheruid, setVoucheruid] = useState("");
    const { Toastshow } = Toast();
    // ---------- Live vouchers load ----------
    // useEffect(() => {
    //     const load = async () => {
    //         const select_company_uid = Cookies.get("select_company_uid");

    //         const domainQuery = query(
    //             collection(db, servicetablename),
    //             where("companyuid", "==", select_company_uid),
    //             where("vouchermasters", "==", true)
    //         );

    //         const snapshot = await getDocs(domainQuery);

    //         if (!snapshot.empty) {

    //         }
    //     };

    //     load();
    // }, []);

    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        setIsLoading2(true);

        if (!select_company_uid) {
            console.error("No company selected");
            setIsLoading2(false);
            return;
        }

        // Correct path:
        const Query = query(
            collection(db, "accountingfinancedb", select_company_uid, "vouchers"),
            where("voucher_ledger", "==", "user"), 

            //orderBy("indexnumber", "desc"),
        );

        const unsubscribe = onSnapshot(
            Query,
            (snapshot) => {
                const vouchers = snapshot.docs
                    .filter((docSnap) => docSnap.data().usecase !== "master")
                    .map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));
                setVouchersdata(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    }, []);
    useEffect(() => {
        const fetchMasters = () => {
            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            const masterQuery = query(
                collection(db, "accountingfinancedb", select_company_uid, "vouchers"),
                where("voucher_ledger", "==", "master"),

            );

            onSnapshot(masterQuery, (snapshot) => {
                const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
                setMasterdata(data);
            });
        };

        fetchMasters();
    }, []);
    //master_vouchers_list
    useEffect(() => {
        const fetchMasters = () => {
            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            const masterQuery = query(collection(db, "master_vouchers_list"), where("status", "==", true));

            // Listen to master voucher list
            const unsubscribe = onSnapshot(masterQuery, async (snapshot) => {
                const masterList = snapshot.docs.map((d) => ({
                    id: d.id,
                    ...d.data(),
                }));

                if (masterList.length === 0) return;

                const vouchersRef = collection(
                    db,
                    "accountingfinancedb",
                    select_company_uid,
                    "vouchers"
                );

                // Listen to company's vouchers
                onSnapshot(vouchersRef, (companySnap) => {
                    const companyVouchers = companySnap.docs.map((d) => d.data().voucherid);

                    // Filter: take only voucherids NOT present in company vouchers
                    const filteredMasters = masterList.filter(
                        (m) => !companyVouchers.includes(m.voucherid)
                    );

                    setMaster_vouchers_listdata(filteredMasters);
                });
            });

            return () => unsubscribe();
        };

        fetchMasters();
    }, []);


    // ---------- Detect URL UID (reload support) ----------
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");

        if (uid) {
            setVoucheruid(uid);
            setIsedit(true);
        } else {
            setIsedit(false);
        }
    }, [window.location.search]);
    // ↑ Component updates anytime URL changes

    // ---------- Open voucher edit ----------
    const openEditVoucher = (uid) => {
        navigate(`?page=vouchers_edit&uid=${uid}`);   // update URL

    };

    // ---------- Close edit ----------
    const closeEdit = () => {
        navigate("?page=vouchers_master");     // remove uid from URL
        setIsedit(false);
        setVoucheruid("");
    };
    //master_vouchers_list
    const voucherList = [
        //  { name: "Payment Voucher", desc: "Used for recording outgoing payments." },
        { name: "Contra Voucher", desc: "Used for cash/bank internal transfers." },
        //{ name: "Journal Voucher", desc: "Used for adjustments and non-cash entries." },
        { name: "Sales Voucher", desc: "Used for recording sales transactions." },
        { name: "Purchase Voucher", desc: "Used for recording purchase transactions." },
        { name: "Debit Note Voucher", desc: "Issued when goods are returned or overcharged." },
        { name: "Credit Note Voucher", desc: "Issued when giving credit or refund due to return." },
        { name: "Expense Voucher", desc: "Used for recording business expenses." },
        { name: "Cash Voucher", desc: "Used for recording cash transactions." },
        { name: "Bank Voucher", desc: "Used for recording bank-related entries." },
        { name: "Petty Cash Voucher", desc: "Used for small day-to-day expenses." },
        { name: "Transfer Voucher", desc: "Used for recording internal transfers." },
        { name: "Adjustment Voucher", desc: "Used for account balancing and adjustments." },
        { name: "Opening Balance Voucher", desc: "Used for entering opening balances." },
        { name: "Closing Balance Voucher", desc: "Used for closing day/month accounts." },
        { name: "Salary Voucher", desc: "Used for recording salary payments." },
        { name: "Stock Voucher", desc: "Used for stock and inventory adjustments." },
        { name: "Purchase Return Voucher", desc: "Used for recording goods returned to supplier." },
        { name: "Sales Return Voucher", desc: "Used for recording goods returned by customer." }
    ];
    //  const CreateAllMasters = async (voucherid, voucher_name, description, logo_url) => {
    //     const accountguid = Randomcode(25);
    //      const result = await Ledger_accounts_manager({
    //                         accountguid,
    //                         voucherid,
    //                         editable: false,
    //                         ledger_type: "credit",                     
    //                     })
    //                       if (result.success) {
    //       Toastshow("All vouchers master created successfully.");
    //                       }else{
    //                         Toastshow("Error creating vouchers.");
    //                       }
    //                 }

    const CreateAllMasters = async (voucherid, voucher_name, slug, voucher_type,entry_type, usecase_type, description, ledger_account, logo_url) => {
        try {

            if (!voucher_name || !voucher_name.trim()) {
                Toastshow("Please enter oucher name.");
                return;
            }
            if (!description || !description.trim()) {
                Toastshow("Please enter Description.");
                return;
            }
            if (!voucherid || !voucherid.trim()) {
                Toastshow("Please enter voucherid.");
                return;
            }

            // const slug = voucher_name.toLowerCase().replace(/\s+/g, "_");
            //const voucherid = Randomcode(22);
            const data = {
                voucherid,
                voucher: voucher_name,
                slug: slug,
                logo_url,
                ledger_account,
                description: description,
                voucher_ledger: "master",
                editable: true,
                amount: 0,
                paypublic: false,
                usecase_type,
                voucher_type,
                entry_type
            };
            const result = await Save_voucher(data);
            //
            if (result.success) {
                const accountguid = Randomcode(25);
                if (ledger_account == true) {

                    const data = {
                        name: voucher_name,
                        accountguid,
                        logo_url,
                        mobile: "",
                        slug: slug + "ac",
                        usecase: "master",
                        description: description,
                        account_type: "master",
                        status: true,
                    };
                    //
                    const result = await Create_ledger_account(data);
                    if (result.success) {
                        const accountsmanagerid= Randomcode(25);
                        
                        const result2 = await Ledger_accounts_manager({
                            accountsmanagerid,
                            accountguid,
                            voucherid,
                            account_type: "master",
                            ledger_type: "=",
                            status: true,
                        })
                        if (result2.success) {
                            const logid = Randomcode(25);
                            if (!voucher_type || !voucher_type.trim()) {
                                Toastshow("Please Select role type.");
                                return;
                            }
                            const dataupdates = {
                                log_id: logid,
                                //
                                status: true,
                                // Add other necessary fields here
                            };
                            create_log(logid, dataupdates, voucherid, "Install", voucher_type, voucher_name);
                        } else {
                            Toastshow(result2.error || `Failed: ${voucher_name}`);
                            return;
                        }
                    }
                }

                Toastshow("All vouchers master created successfully.");
            } else {
                Toastshow(result.error || `Failed: ${voucher_name}`);
                return;
            }
            if (result.success && ledger_account === false) {
                Toastshow("vouchers master created successfully.");
            } else {
                Toastshow(result.error || `Failed: ${voucher_name}`);
                return;
            }
            // await updateDoc(doc(db, servicetablename, select_company_uid), {
            //     vouchermasters: false
            // });
        } catch (error) {
            Toastshow("Error creating vouchers.");
        }
    };

    const create_log = async (logid, dataupdates, filedid, account_type, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + description;
        const log_data = {
            logid,
            history_type: "Install",
            servicetablename: "accountingfinancedb",
            tablename: "vouchers",
            filedname: "voucherid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
            accountguid: "",
            description: description,
            account_type: account_type,
            
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    return (
        <div>

            <>

                <div className="b-bottom">
                    <table>
                        <tr>
                            <td ><div

                                className="button-ui0 text-h2 bold p-2"
                            >
                                <MdOutlineReceiptLong className="icon" />POS Receipt Master
                            </div></td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/accounting")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            
                    <div className="post-container p-2">
                        <div className="post_updates">   <Pos_receipt_master_create /></div>
                        <div className="post_div">
                            <div className="ui-grid-250">
                             

                                {IsLoading2 ? (
                                    <></>
                                ) : vouchersdata.length === 0 ? (
                                    <div className="text-h2 bold p-5">No oucher Found</div>
                                ) : (
                                    vouchersdata.map((row) => (
                                        <div
                                            className="ui-items items-back items-back shadow hover rounded cursor"
                                            onClick={() => openEditVoucher(row.voucherid)}
                                            key={row.voucherid}
                                        >

                                            <table>
                                                <tr>
                                                    <td  > <div
                                                        className="button-ui3 bold"
                                                        style={{ color: row.status === true ? "green" : "red" }}
                                                    >
                                                        #{row.indexnumber} {row.status === true ? "Activate" : "Deactivate"}
                                                    </div></td>
                                                    <td width={130} className='text-h3 text-r'>
                                                        {row.date_time?.toDate ? (
                                                            <>
                                                                {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                {row.date_time.toDate().toLocaleTimeString()}
                                                            </>
                                                        ) : (
                                                            <div className='contact-details'>No date</div>
                                                        )}
                                                    </td>
                                                </tr>
                                            </table>
                                            <img src={row.logo_url || logo_default} alt={row.voucher} className="brand-thumbnail" />

                                            <div className="flex p-11 b-bottom">
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <span className="text-h2 bold">Amount</span>
                                                        </td>
                                                        <td className="text-r">
                                                            <div className="text-h2 bold">  <span className="text-h2">₹</span>{row.amount || 0}<span className="text-off text-h3">/-</span></div>
                                                        </td>

                                                    </tr>
                                                </table>


                                            </div>
                                            <div className="p-1">
                                                <div className="text-h2 fcap bold">{row.voucher}</div>

                                                <div className="text-h3 fcap m-b">
                                                    {row.description?.substring(0, 200)}...
                                                </div>

                                                {row.child?.dealname && (
                                                    <div>
                                                        <span className="red text-h3 items-back rounded-sm">
                                                            {row.child.dealname}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>


                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
             
            </>

        </div>
    );
}